import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { INDUSTRIES } from "../data/content";
import Reveal from "../components/Reveal";
import Seo from "../components/Seo";

export default function Industries() {
  return (
    <div data-testid="page-industries">
      <Seo
        title="Industries We Serve — Restaurants, Retail, Contractors, Hospitality"
        description="We serve restaurants, retail, contractors, plumbers, hotels, professional services, startups, and small businesses across Dallas–Fort Worth."
        path="/industries"
      />
      <section className="bg-white pt-20 pb-10">
        <div className="container-wide max-w-4xl">
          <div className="overline mb-6">Industries</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]" data-testid="industries-page-headline">
            Built for the businesses that keep DFW moving.
          </h1>
          <p className="mt-6 text-lg text-[#4B5563] leading-relaxed">
            We work across restaurants, retail, contractors, home services, hospitality, professional services, and startups. Every engagement is tailored to the realities of the industry.
          </p>
        </div>
      </section>

      <section className="bg-[#F7F7F8]">
        <div className="container-wide py-16 md:py-24 space-y-10">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.slug}>
              <div className={`grid md:grid-cols-12 gap-8 items-center bg-white border border-gray-100`} data-testid={`industry-row-${ind.slug}`}>
                <div className={`md:col-span-5 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                  <img src={ind.image} alt={ind.name} className="w-full h-72 md:h-80 object-cover" />
                </div>
                <div className={`md:col-span-7 p-8 md:p-12 ${i % 2 === 1 ? "md:order-1" : ""}`}>
                  <div className="overline mb-3">Industry</div>
                  <h2 className="font-serif text-2xl md:text-3xl tracking-tight leading-tight">{ind.name}</h2>
                  <p className="mt-4 text-[#4B5563] leading-relaxed">{ind.body}</p>
                  <Link to="/growth-assessment" className="btn btn-ghost mt-6" data-testid={`industry-cta-${ind.slug}`}>
                    Explore how we can help <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
